export const STORE_LAST_PAGE_WAS_ORDER_CONFIRMATION = 'STORE_LAST_PAGE_WAS_ORDER_CONFIRMATION';
